import React from 'react';

export class ChevronRightIcon extends React.PureComponent {
  render() {
    return (
      <svg width="15" height="15" viewBox="0 0 15 15" {...this.props}>
        <path
          fill="currentColor"
          d="M 3.054485,1.3636359 9.1908489,7.4999999 3.0544849,13.636364 4.4455158,15 11.945515,7.4999999 4.4455158,-1.25e-7 Z"
        />
      </svg>
    );
  }
}
